import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const CustomerEditModel = {
    headerTitle: i18n.t('servicesystem.common_objects.customer.customer'),
    enabledIcon: "mdi-domain",
    disabledIcon: "mdi-domain-off",
    listItemTextKey: "Name",

    fields: [
        { type: "input", label: i18n.t('servicesystem.common_objects.customer.customer_number'), valuekey: "Id", editable: false, rules: "", defaultValue: -1 },
        { type: "input", label: i18n.t('servicesystem.common_objects.customer.customer_name'), valuekey: "Name", editable: true, rules: "noempty", defaultValue: "" },
        { type: "input", label: i18n.t('servicesystem.common_objects.customer.organization_number'), valuekey: "OrganisationNumber", editable: true, rules: "", defaultValue: "" },

        { type: "switch", label: i18n.t('servicesystem.common_objects.customer.free_from_vat'), valuekey: "FreeFromVat", editable: true, defaultValue: true },

        { type: "address", valuekey: "DefaultDeliveryAddress", editable: true, rules: "noname", defaultValue: { DisplayName: '', Street: '', Zip: '', City: '', Country: '' } },

        { type: "switch", label: i18n.t('servicesystem.common_objects.customer.active'), valuekey: "IsActive", editable: "onlyedit", defaultValue: true },
    ],

    viewMore: {
        routeName: "ViewCustomer",
        params: { customerId: "Id" }
    },

    methods: {
        async save(customer) {
            return clientAPI.methods.changeCustomerContactById(customer);
        },
        async create(newcustomer) {
            return clientAPI.methods.createCustomer(newcustomer);
        },
    }
}

export default CustomerEditModel;